// src/store/services/coach.js
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from "../../feathers-client";

class Competency_Progress extends BaseModel {
  constructor (data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = "Competency_Progress";
  // Define default properties here
  static instanceDefaults () {
    return {
      id: null,
      progress: null,
      practice: null,
      relevancy: null,
      traineeCompetenciesId: null,
      createdAt: null,
      updatedAt: null
    };
  }
}
const servicePath = "competency-progress";
const servicePlugin = makeServicePlugin({
  Model: Competency_Progress,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
